<template>
  <div :class="$style.root">
    <img :class="$style.img" src="./img/banner.png" alt="" />
    <img @click="gotoDownload" :class="$style.img" src="./img/goods.png" alt="" />
    <div class="u-textCenter">
      <button @click="gotoDownload" :class="$style.btn">下载丽芙家居APP</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PinPanZhuangQu",
  methods: {
    gotoDownload() {
      window.location.href = this.$paths.appDownload();
    },
  },
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.img {
  display: block;
  width: 100%;
}

.btn {
  margin-top: 15px;
  margin-bottom: 15px;
  width: rem(315px);
  height: rem(50px);
  line-height: rem(50px);
  background: rgba(233, 90, 89, 1);
  border-radius: rem(25px);
  font-size: rem(17px);
  color: rgba(255, 255, 255, 1);
}
</style>
